<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import { formatCount } from '@/utils/formatCount'

const props = defineProps<{
  book: any
  moduleName?: string
}>()

const emit = defineEmits<{
  (e: 'click', id: string): void
}>()

// BizBookCover 通过 document.getElementById 做懒加载观察，
// 同一本书可能在多个模块/面板中出现，必须用唯一 DOM id
const coverDomId = uuid()

// 标签行：取前两个标签用 " / " 连接（对照蓝湖 "Excited / Red hot"）
const tagLine = computed(() => {
  const tags = (props.book?.tagList || []).slice(0, 2).map((t: any) => t.name).filter(Boolean)
  return tags.join(' / ')
})

const viewCount = computed(() => formatCount(props.book?.viewUsers))
</script>

<template>
  <div class="book-grid-card cursor-pointer" @click="emit('click', book.id)">
    <BizBookCover
      :id="coverDomId"
      :src="book.contentCoverUrl || ''"
      :small-theater="!!book.small_theater"
      :extra="{
        module_name: moduleName || 'grid',
        author: book.authorInfo?.author,
        ...book,
      }"
      class="card-cover w-full rounded-8px overflow-hidden"
    />
    <p class="mt-8px text-14px font-600 line-clamp-2 text-n-text-1 leading-18px">
      {{ book.contentName }}
    </p>
    <p v-if="tagLine" class="mt-4px text-11px truncate tag-line">
      {{ tagLine }}
    </p>
    <div class="mt-4px flex items-center text-10px text-n-text-2">
      <i-icon-park-outline-preview-open class="w-3 h-3 mr-1 flex-shrink-0" />
      <span>{{ viewCount }}</span>
    </div>
  </div>
</template>

<style scoped>
.card-cover {
  aspect-ratio: 166 / 220;
  object-fit: cover;
}

/* 标签行粉色（对照蓝湖） */
.tag-line {
  color: #ff5ace;
}
</style>
